import { getAccess } from "@helpers/permissionController";

export const REQ_FOR = {
  OPTIONS: {
    SELF: {
      LABEL: "Self",
      VALUE: "self",
    },
    ROOM: {
      LABEL: "Room",
      VALUE: "room",
    },
    DESK: {
      LABEL: "Desk",
      VALUE: "desk",
    },
    BARRACK: {
      LABEL: "Barrack",
      VALUE: "barrack",
    },
    OTHERS: {
      LABEL: "Others",
      VALUE: "others",
    },
  },
};

export const REQ_FOR_OPTIONS = (roles: string[]) => {
  return getAccess(roles, "REQUISITION_VIEW_PAGE")
    ? [
        {
          label: REQ_FOR.OPTIONS.SELF.LABEL,
          value: REQ_FOR.OPTIONS.SELF.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.ROOM.LABEL,
          value: REQ_FOR.OPTIONS.ROOM.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.DESK.LABEL,
          value: REQ_FOR.OPTIONS.DESK.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.BARRACK.LABEL,
          value: REQ_FOR.OPTIONS.BARRACK.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.OTHERS.LABEL,
          value: REQ_FOR.OPTIONS.OTHERS.VALUE,
        },
      ]
    : [
        {
          label: REQ_FOR.OPTIONS.SELF.LABEL,
          value: REQ_FOR.OPTIONS.SELF.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.ROOM.LABEL,
          value: REQ_FOR.OPTIONS.ROOM.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.DESK.LABEL,
          value: REQ_FOR.OPTIONS.DESK.VALUE,
        },
        {
          label: REQ_FOR.OPTIONS.BARRACK.LABEL,
          value: REQ_FOR.OPTIONS.BARRACK.VALUE,
        },
      ];
};
